import ApiService from '@/services/core/api.service'

const VisitRequestService = {
  async get (query) {
    return ApiService.get(`lead-supervisor/visit-requests?${query}`)
  }
}

export default VisitRequestService
